import { Pressable } from '../../../ui/Pressable';
import { SNOOZE_CHOICES, type ChoreItem } from './types';

/** Lifecycle pieces (card xvom08w4BgGT) — the streak celebration and the
 *  cap's options card sit above the list; the "Later" chooser rides its row. */
export function StreakNotice({ streakLabel, setStreakLabel }: {
  streakLabel: string;
  setStreakLabel: (v: string | null) => void;
}) {
  return (
    <div className="ch-streak" id="ch-streak" role="status">
      <span className="ch-streak-text">{streakLabel}</span>
      <Pressable
        className="pear-btn ch-streak-hide"
        aria-label="Hide the list-clear streak notice"
        onClick={() => setStreakLabel(null)}
      >
        Hide
      </Pressable>
    </div>
  );
}

export function CapCard({ cappedChore, busyId, setCapped, tapAssignee, renegotiate }: {
  cappedChore: ChoreItem;
  busyId: string | null;
  setCapped: (v: string | null) => void;
  tapAssignee: (chore: ChoreItem) => Promise<void>;
  renegotiate: (chore: ChoreItem) => Promise<void>;
}) {
  return (
    <div className="rq-card ch-cap" id="ch-cap" role="group" aria-label={`Three moves already used on ${cappedChore.title}`}>
      <p className="rq-composer-label">Three moves already used</p>
      <p className="rq-empty-hint">
        {cappedChore.title} has been put off three times this round — change who is on it or talk it through, instead of moving it again.
      </p>
      <div className="ch-cap-actions">
        <Pressable
          className="pear-btn"
          id="ch-cap-reassign"
          disabled={busyId != null}
          onClick={() => { setCapped(null); void tapAssignee(cappedChore); }}
        >
          Reassign
        </Pressable>
        <Pressable
          className="pear-btn pear-btn-mustard"
          id="ch-cap-renegotiate"
          disabled={busyId != null}
          onClick={() => void renegotiate(cappedChore)}
        >
          Renegotiate
        </Pressable>
      </div>
    </div>
  );
}

export function LaterPanel({ chore, busy, pushLater }: {
  chore: ChoreItem;
  busy: boolean;
  pushLater: (chore: ChoreItem, kind: 'snooze' | 'defer', returnAt?: number) => Promise<void>;
}) {
  return (
    <div className="ch-later-panel" id="ch-later-panel" role="group" aria-label={`Move ${chore.title} later`}>
      <span className="ch-later-label">Come back…</span>
      <div className="ch-later-choices">
        {SNOOZE_CHOICES.map(choice => (
          <Pressable
            key={choice.key}
            className="underline-select ch-later-chip"
            disabled={busy}
            aria-label={`Snooze ${chore.title} ${choice.label.toLowerCase()}`}
            onClick={() => void pushLater(chore, 'snooze', Date.now() + choice.ms)}
          >
            {choice.label}
          </Pressable>
        ))}
        <Pressable
          className="underline-select ch-later-chip"
          disabled={busy}
          aria-label={`Defer ${chore.title} to its next due date`}
          onClick={() => void pushLater(chore, 'defer')}
        >
          Defer to next due
        </Pressable>
      </div>
      <p className="rq-empty-hint ch-later-count" id="ch-later-count" role="status">
        {chore.snoozeCount >= 3
          ? 'Three moves used this round — the next one needs a change of plan.'
          : `${chore.snoozeCount} of 3 moves used this round.`}
      </p>
    </div>
  );
}
